import React, { useReducer } from "react";

import AuthContext from "./Auth.context";
import AuthReducer from "./Auth.reducer";

const initialState = {
  isAuthenticated: localStorage.getItem("jwt") ? true : false,
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null,
};
const AuthState = (props) => {
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
